// extracted by mini-css-extract-plugin
export const mainContainer = "Styles-module--mainContainer--1DA4y";
export const column = "Styles-module--column--3guZJ";
export const columnTitle = "Styles-module--columnTitle--3sp9a";
export const columnDescription = "Styles-module--columnDescription--2k8oh";
export const copyright = "Styles-module--copyright--bv6L9";
export const quickLink = "Styles-module--quickLink--3RQUJ";
export const contactDetailsContainer = "Styles-module--contactDetailsContainer--2Tj2V";
export const contactDetailsText = "Styles-module--contactDetailsText--1YVgI";
export const contactDetailsTextNoLink = "Styles-module--contactDetailsTextNoLink--1f0a-";